import { defer, isArray } from 'lodash-es';
import anime from 'animejs';
import scroll from 'core/scroll';
import { bindMethod } from 'helpers/bind';
import store from 'store';
import modulesMap from 'core/modulesMap';
import { EASE_OUT, frameToMs } from 'helpers/easings';
import { durations } from 'components/menu/motion';
import Page from './Page';
export default class PanelPage extends Page {
    static pageName = 'PanelPage<Type';
    async askPreload(previousPage) {
        this.el.classList.add('appearing');
        await super.askPreload(previousPage);
        await this.resetScroll();
    }
    initialized() {
        super.initialized();
        this.resize();
    }
    getModulesMap() {
        return {
            ...modulesMap
        };
    }
    async resetScroll() {
        if (this.pageManager?.container.scrollTop)
            await scroll.scrollTo(0, { target: this.pageManager.container, duration: 200 });
    }
    /* SHOW */
    async show(previousPage, previousEl) {
        this.resize();
        this.invoke('show');
        const isIdentical = previousEl?.innerHTML === this.el?.innerHTML;
        if (isIdentical)
            return super.show(previousPage, previousEl);
        const isSamePage = previousPage === this.pageName() && previousPage !== PanelPage.pageName;
        await anime({
            opacity: {
                value: [0, 1],
                duration: frameToMs(15),
                easing: 'linear',
                delay: frameToMs(15)
            },
            targets: this.el,
            translateX: {
                value: ['50%', '0%'],
                duration: isSamePage ? 0 : frameToMs(25),
                easing: EASE_OUT
            },
            changeBegin: () => {
            },
            complete: () => {
                defer(() => this.resize());
            }
        }).finished;
    }
    transitionComplete() {
        this.el.classList.remove('appearing');
        super.transitionComplete();
    }
    /* HIDE */
    async hide(nextPage, previousEl) {
        const isIdentical = previousEl?.innerHTML === this.el?.innerHTML;
        if (isIdentical)
            return super.hide(nextPage, previousEl);
        const isSamePage = nextPage === this.pageName() && nextPage !== PanelPage.pageName;
        await anime(isSamePage ? {
            targets: this.el,
            opacity: {
                value: [1, 0],
                duration: frameToMs(10),
                easing: 'linear',
                delay: frameToMs(10)
            }
        } : {
            targets: this.el,
            opacity: {
                value: [1, 0],
                duration: durations.FIRST_PANEL_OPACITY_OUT / 2,
                easing: 'linear'
            }
        }).finished;
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        if (isArray(this.refs.closePanel))
            this.refs.closePanel.forEach((el) => el[method]('click', this.closePanel));
        else
            this.refs.closePanel?.[method]('click', this.closePanel);
    }
    closePanel() {
        store.panel.set(null);
    }
    flush() {
        super.flush();
        this.resize();
    }
}
